module.exports = __webpack_public_path__ + "static/media/08-quiz.3135b22d.png";